var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "#0A142F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0932 14.0205H21.7016C21.8495 14.0205 21.9696 13.9074 21.9696 13.7679V12.2524C21.9696 12.1129 21.8495 11.9998 21.7016 11.9998H20.0932C18.4677 11.9998 17.1445 13.2461 17.1445 14.7783V16.5465H15.2681C15.1201 16.5465 15 16.6597 15 16.7991V18.3147C15 18.4541 15.1201 18.5673 15.2681 18.5673H17.1445V23.8719C17.1445 24.0113 17.2646 24.1245 17.4126 24.1245H19.0209C19.1689 24.1245 19.289 24.0113 19.289 23.8719V18.5673H21.1655C21.2807 18.5673 21.3831 18.4976 21.4201 18.3945L21.9562 16.8789C21.9836 16.8021 21.9696 16.7173 21.9192 16.6511C21.8683 16.5854 21.7879 16.5465 21.7016 16.5465H19.289V14.7783C19.289 14.3605 19.6498 14.0205 20.0932 14.0205Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.52c5e564bbd2528f4c8c3333e7678e54.svg";
export { ForwardRef as ReactComponent };